import { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Spinner
} from "reactstrap";
import { withNamespaces } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import ControlService from "src/modules/data-protection/apis/ControlService";
import { toast } from "react-toastify";

const JustificationModal = ({ t, isOpen, toggle, controlId, value, onSaved }) => {
    const [text, setText] = useState(value || "");

    const saveJustificationMutate = useMutation({
        mutationFn: async (payload) => {
            const service = ControlService.getInstance();
            return await service.updateJustification(controlId, payload);
        },
        onSuccess: () => {
            toast(t("Justification updated successfully."), {
                type: "success"
            });
            
            toggle();

            onSaved && onSaved();
        },
        onError: () => {
            toast(t("Failed to update justification. Please try again."), {
                type: "error"
            });
        }
    });

    const handleSave = () => {
        saveJustificationMutate.mutate({
            reason: text
        });
    };

    useEffect(() => {
        setText(value || "");
    }, [ value ])

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('Edit Justification')}
            </ModalHeader>
            <ModalBody>
                <Input
                    type="textarea"
                    rows="5"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder={`${t('Enter justification')}...`}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSave}
                    disabled={saveJustificationMutate.isLoading}
                >
                    {saveJustificationMutate.isLoading && (
                        <Spinner size="sm" className="me-2" />
                    )}

                    {t('Save')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    JustificationModal
);
